<!--The content below is only a placeholder and can be replaced.-->
<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>
